import { useState, useEffect } from "react"
import shortid from "shortid"
import StripeCheckout from "react-stripe-checkout"
import axios from "axios"
import axiosWithAuth from "../../utils/axiosWithAuth"

import { diningData } from "../../data/diningData"

import "../../styles/CartModal.css"

import { toast } from "react-toastify"
import 'react-toastify/dist/ReactToastify.css';
toast.configure()

function CartModal({ setCurrentItem, cart, setCart, cartModal, setCartModal, setEdit, user, orderid, onClose, hoursOfOp }) {
  const [ cartMes, setCartMes ] = useState("No items in your cart!")
  const [ cartErr, setCartErr ] = useState("")

  const closeOnEscape = e => {
    if ((e.charCode || e.keyCode) === 27) {
      onClose()
    }
  }

  useEffect(() => {
    document.body.addEventListener("keydown", closeOnEscape)

    return function cleanup() {
      document.body.removeEventListener("keydown", closeOnEscape)
    }
  })
  
  if (cartModal === false) {
    return null
  }

  function financial(x) {
    return Number.parseFloat(x).toFixed(2);
  }

  const calcOrderTotal = () => {
    if (cart.length > 0) {
      let itemPriceArr = cart.map(item => {
        return parseFloat(item.total)
      })
  
      let itemPriceTotal = itemPriceArr.reduce((partialSum, a) => partialSum + a, 0);
      let taxedTotal = itemPriceTotal + (itemPriceTotal * 0.08)
      let processedTotal = taxedTotal + (taxedTotal * 0.029) + 0.31
  
      return financial(processedTotal)
    } else {
      return null
    }
  }

  let orderTotal = calcOrderTotal()
  let product = {
    name: "Roma Order",
    price: Number.parseInt((Number.parseFloat(orderTotal) * 100).toFixed(0))
  }

  const handleRemove = remID => {
    cart = cart.filter(item => item.id !== remID)
    return setCart([...cart])
  }

  const handleEdit = editItem => {
    setEdit(true)
    setCartModal(false)

    handleRemove(editItem.id)

    let findCurrentItem = []
    
    if (findCurrentItem.length < 1) {
      findCurrentItem = diningData.appetizers.filter(item => item.name === editItem.name)
    } 
    
    if (findCurrentItem.length < 1) {
      findCurrentItem = diningData.deliSandwiches.filter(item => item.name === editItem.name)
    } 
    
    if (findCurrentItem.length < 1) {
      findCurrentItem = diningData.hotSubs.filter(item => item.name === editItem.name)
    }

    if (findCurrentItem.length < 1) {
      findCurrentItem = diningData.specialtySalads.filter(item => item.name === editItem.name)
    }

    if (findCurrentItem.length < 1) {
      findCurrentItem = diningData.calzones.filter(item => item.name === editItem.name)
    }

    if (findCurrentItem.length < 1) {
      findCurrentItem = diningData.dinners.filter(item => item.name === editItem.name)
    }

    if (findCurrentItem.length < 1) {
      findCurrentItem = diningData.pizzas.filter(item => item.name === editItem.name)
    }
    
    setCurrentItem({...findCurrentItem[0], show: true, editItem: editItem})
  }

  async function handleToken(token) {
    if (cart.length > 0) {
      await axiosWithAuth().post("/stripe/checkout", { token, product })
      .then(response => {
        if (response.status === 200) {
          toast(`Thanks ${user.data.user.display_name}! `)
          setCartErr("")
  
          let newOrder = {
            user_id: user.data.user.id,
            order_id: orderid
          }
          
          axiosWithAuth().post("/order/dining", newOrder)
            .then(() => {
              let urlDining = "https://roma-be.herokuapp.com/api/item/dining"
              
              let requestArray = cart.map(item => {
                let newItem = {
                  order_id : orderid,
                  servings: item.servings,
                  name: item.name,
                  quantity: item.quantity,
                  size: item.size,
                  unit: item.unit,
                  unit_list: item.unitList,
                  detail: item.detail,
  
                  toppings: JSON.stringify(Object.values(item.toppings)),
                  extras: JSON.stringify(Object.values(item.extras)),
  
                  additions: JSON.stringify(Object.values(item.additions)
                    .filter(filterItem => filterItem.servings !== 0)
                    .map(submitItem => { return submitItem.name + "(" + submitItem.servings + ")" })
                  ),                
                  spreads: JSON.stringify(Object.values(item.spreads)
                    .filter(filterItem => filterItem.servings !== 0)
                    .map(submitItem => { return submitItem.name })
                  ),
                  sauces: JSON.stringify(Object.values(item.sauces)
                    .filter(filterItem => filterItem.servings !== 0)
                    .map(submitItem => { return submitItem.name + "(" + submitItem.servings + ")" })
                  ),
                  dressings: JSON.stringify(Object.values(item.dressings)
                    .filter(filterItem => filterItem.servings !== 0)
                    .map(submitItem => { return submitItem.name })
                  ),
                }
  
                return axios.post(urlDining, newItem, { headers: { Authorization: user.data.token } })
              })
  
              axios.all(requestArray)
                .then(axios.spread(() => {
                  return
                }))
                .catch(() => {
                  return
                })
              
            })
            .catch(() => {
              let urlDining = "https://roma-be.herokuapp.com/api/item/dining"
              
              let requestArray = cart.map(item => {
                let newItem = {
                  order_id : orderid,
                  servings: item.servings,
                  name: item.name,
                  quantity: item.quantity,
                  size: item.size,
                  unit: item.unit,
                  unit_list: item.unitList,
                  detail: item.detail,
  
                  toppings: JSON.stringify(Object.values(item.toppings)),
                  extras: JSON.stringify(Object.values(item.extras)),
  
                  additions: JSON.stringify(Object.values(item.additions)
                    .filter(filterItem => filterItem.servings !== 0)
                    .map(submitItem => { return submitItem.name + "(" + submitItem.servings + ")" })
                  ),                
                  spreads: JSON.stringify(Object.values(item.spreads)
                    .filter(filterItem => filterItem.servings !== 0)
                    .map(submitItem => { return submitItem.name })
                  ),
                  sauces: JSON.stringify(Object.values(item.sauces)
                    .filter(filterItem => filterItem.servings !== 0)
                    .map(submitItem => { return submitItem.name + "(" + submitItem.servings + ")" })
                  ),
                  dressings: JSON.stringify(Object.values(item.dressings)
                    .filter(filterItem => filterItem.servings !== 0)
                    .map(submitItem => { return submitItem.name })
                  ),
                }
  
                return axios.post(urlDining, newItem, { headers: { Authorization: user.data.token } })
              })
  
              axios.all(requestArray)
                .then(axios.spread(() => {
                  return
                }))
                .catch(() => {
                  return
                })
              return
            })
  
          setCartMes("Thank you! Your order has been placed. (Est. 20 min.)")
          setCart([])
        }
        
      })
      .catch(() => {
        toast("Sorry, your card could not be processed. Please try again.")
      })
      
    }
  }

  return (
    <div className="c-overlay">

      <div className="c-content">
        
        <div className="c-header">
          <div className="c-title-container">
            <h4 className="c-title">Order Summary</h4>
            <span className="c-title-sub">*Orders are subject to a card processing fee and %8 Rhode Island Sales, and Meals and Beverage Tax.</span>
          </div>
          <div>
            <button className="c-go-back-button-x" onClick={onClose}>X</button>
          </div>
        </div>

        <div className="c-body">
          {cartErr ?
            <div>{cartErr}</div> 
          : null}
          {cart.length > 0 ?
            cart.map(item => (
              <div className="c-body-section" key={shortid.generate()}>
                <div className="c-section-title">
                  <div className="c-summary-snu">
                    <span className="c-summary-servings">({item.servings})</span>
                    <span className="c-summary-name">{item.name}</span>
                    {item.quantity !== null || item.size !== null || item.unitList !== null ?
                      item.name !== "Garlic Knots" ?
                        <>
                          {item.size && item.unitList ?
                            item.name === "Build Your Own Brick Oven Pizza" ?
                              <span className="m-summary-unit">({item.quantity}{item.size} {item.unitList})</span> :
                              <span className="m-summary-unit">({item.quantity}{item.size})</span> :
                              item.size && !item.unitList ?
                                <span className="c-summary-unit">({item.quantity}{item.size})</span> :
                                <span className="c-summary-unit">({item.quantity}{item.unitList})</span>}
                        </> :
                        item.unitList === "1 Pcs. ($0.75/ea)" ?
                          <span className="c-summary-unit">(1 Pcs.)</span> :
                          <span className="c-summary-unit">(3 Pcs.)</span>
                    : null}
                    
                  </div>

                  <div className="c-summary-p">
                    <span className="c-summary-total">Total:</span>
                    <span>${(item.total * 1).toFixed(2)}</span>
                  </div>
                </div>

                <div className="c-section-content-container">
                  <div className="c-section-content">
                    <div className="c-content-summary">
                      <div className="c-summary-snutd-container">
                        <div className="c-summary-td">
                          {/* Summary Detail */}
                          {item.detail !== "" ?
                            <span className="c-summary-detail">*{item.detail}</span> 
                          : null}

                          {/* Summary Spreads */}
                          {Object.entries(item.spreads).map(([key, value]) => {
                            if (value.servings !== 0) {
                              return <span className="m-summary-toppings" key={shortid.generate()}>{value.name}</span>
                            } else { 
                              return null 
                            }
                          })}

                          {/* Summary Toppings */}
                          {Object.entries(item.toppings).map(([key, value]) => {
                            return <span className="m-summary-toppings" key={shortid.generate()}>{value}</span>
                          })}

                          {/* Summary Extras */}
                          {Object.entries(item.extras).map(([key, value]) => {
                            return <span className="m-summary-toppings" key={shortid.generate()}>{value}</span>
                          })}

                          {/* Summary Additions */}
                          {Object.entries(item.additions).map(([key, value]) => {
                            if (value.servings !== 0) {
                              return <span className="m-summary-additions" key={shortid.generate()}>ADD ({value.servings}){value.name}</span>
                            } else { 
                              return null 
                            }
                          })}                          

                          {/* Summary Sauces */}
                          {Object.entries(item.sauces).map(([key, value]) => {
                            if (value.servings !== 0) {
                              return <span className="m-summary-toppings" key={shortid.generate()}>SIDE ({value.servings}){value.name}</span>
                            } else { 
                              return null 
                            }
                          })}

                          {/* Summary Dressings */}
                          {Object.entries(item.dressings).map(([key, value]) => {
                            if (value.servings !== 0) {
                              return <span className="m-summary-toppings" key={shortid.generate()}>SIDE ({value.servings}){value.name}</span>
                            } else { 
                              return null 
                            }
                          })}
                        </div>    

                        <div className="c-summary-er">
                          <button className="c-edit-button" onClick={() => handleEdit(item)}>Edit</button>
                          <button className="c-remove-button" onClick={() => handleRemove(item.id)}>Remove</button>
                        </div>
                      </div>                      
                    </div>
                  </div>
                </div>
              </div>
            ))
          : <div className="c-message">{cartMes}</div>}
        </div>

        <div className="c-footer">
          <button className="c-go-back-button" onClick={onClose} >Back to Menu</button>
          <div className="c-order-total-container">
            <span className="c-order-total">Order Total</span>
            {orderTotal !== null && orderTotal !== undefined ?
              <span className="c-order-total-price">${orderTotal}</span> :
              <span className="c-order-total-price">$0.00</span>
            }
          </div>
          {hoursOfOp ?
            cart.length > 0 ?
              <StripeCheckout 
                className="c-place-order-button"
                stripeKey={process.env.REACT_APP_PK}
                token={handleToken}
                name="Order to Roma Ristorante"
              /> : 
              <button className="c-go-back-button">Pay With Card</button> :
            <button className="c-go-back-button">Pay With Card</button>
          }
        </div>
      </div>
    </div>
  )
}

export default CartModal
